module.exports = __webpack_public_path__ + "img/squishiland-3.1ca2b980.png";